<template>
  <layout-register :step="step" :title-step="titlePage">
    <template #description-page>
      {{ $t('m77') }}
    </template>
    <form
      @submit="
        e => {
          e.preventDefault();
          sendFilesLicense();
        }
      "
    >
      <div class="row">
        <div class="col-md-6 col-12">
          <a-input-file-background
            icon="ic-camera"
            background="lc-front-chl"
            :label="$t('m73')"
            v-model="form.fileDriveFront.value"
            :error="form.fileDriveFront.error.length > 0"
            :errorMessage="form.fileDriveFront.error"
          />
        </div>
        <div class="col-md-6 col-12">
          <a-input-file-background
            icon="ic-camera"
            background="lc-back-chl"
            :label="$t('m74')"
            v-model="form.fileDriveBack.value"
            :error="form.fileDriveBack.error.length > 0"
            :errorMessage="form.fileDriveBack.error"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-7 col-xs-12 col-sm-12 col-12">
          <a-btn
            class="next-step-button"
            primary
            type="submit"
            :loading="loadingBtn"
          >
            {{ $t('m15') }} 7
          </a-btn>
        </div>
      </div>
    </form>
  </layout-register>
</template>

<script>
import AInputFileBackground from '@/components/ui/AInputFileBackground';
import ABtn from '@/components/ui/ABtn';

import { validator } from '@/mixins/validator.js';
import { imageConverter } from '@/mixins/imageConverter.js';

export default {
  name: 'DocumentDrivingLicense',
  components: {
    AInputFileBackground,
    ABtn,
  },
  mixins: [validator, imageConverter],
  data() {
    return {
      step: 6,
      titlePage: this.$t('m171'),
      loadingBtn: false,
      form: {
        fileDriveFront: {
          value: '',
          error: '',
          rules: [],
        },
        fileDriveBack: {
          value: '',
          error: '',
          rules: [],
        },
      },
    };
  },
  mounted() {
    this.form.fileDriveFront.rules = [this.rules.required];
    this.form.fileDriveBack.rules = [this.rules.required];
  },
  methods: {
    async sendFilesLicense() {
      if (this.validateForm()) {
        this.loadingBtn = true;

        let photoFrontBlob = await this.srcToBlob(
          URL.createObjectURL(this.form.fileDriveFront.value),
          'image/jpeg',
          0.1,
        );
        let photoBackBlob = await this.srcToBlob(
          URL.createObjectURL(this.form.fileDriveBack.value),
          'image/jpeg',
          0.1,
        );
        const formData = new FormData();
        formData.append('fileDriveFront', photoFrontBlob);
        formData.append('fileDriveBack', photoBackBlob);

        this.$store.dispatch('register/documentDrive', formData).then(resp => {
          this.loadingBtn = false;
          if (resp.registrationStep) {
            this.$router.push({ name: resp.registrationStep });
          }
        });
      }
    },
  },
};
</script>
